import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--tabs-scroll"
// Ui::TabsComponent with phone_scroll (CONEK-9333): below sm the tab list is a
// single row that scrolls sideways instead of wrapping to three or four rows.
// On load the active tab may sit past the right edge, out of sight, so it is
// scrolled to the middle of the row — only the row moves, never the page.
export default class extends Controller {
  connect() {
    const list = this.element
    if (list.scrollWidth <= list.clientWidth) return

    const active = list.querySelector('[aria-selected="true"]')
    if (!active) return

    const centred = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2
    list.scrollLeft = Math.max(0, centred)
  }
}
